import React from 'react';
import PropTypes from 'prop-types';
import PromotionBanner from './PromotionBanner';
import PromotionBannerBehindExperiment from './PromotionBannerBehindExperiment';

const PromotionBannerFactory = props => {
  return props.experiment?.enabled
    ? <PromotionBannerBehindExperiment {...props} />
    : <PromotionBanner {...props} />;
};

PromotionBannerFactory.propTypes = {
  experiment: PropTypes.shape({
    enabled: PropTypes.bool
  }),
};

export default PromotionBannerFactory;
